import { get } from 'lodash';
import env from 'utilities/env';

export const hasOneOrMoreErrors = (errors, key) => get(errors, key, []).length > 0;

// The order matters here, and this may report false positives for unlisted browsers.
const BROWSER_MAP = [
  ['Firefox', 'Mozilla Firefox'],
  ['Opera', 'Opera'],
  ['OPR', 'Opera'],
  ['Trident', 'Microsoft Internet Explorer'],
  ['Edge', 'Microsoft Edge'],
  ['Edg', 'Microsoft Edge'],
  ['Chrome', 'Google Chrome'],
  ['Safari', 'Apple Safari']
];

export const getUserBrowser = () => {
  const { userAgent } = navigator;
  const agentIndex = BROWSER_MAP.findIndex((tuple) => {
    const agent = tuple[0];
    return userAgent.indexOf(agent) > -1;
  });
  return get(BROWSER_MAP, [agentIndex, 1], 'unknown');
};

export const intercomLoader = ({ userId, name, email }) => {
  if (env('DISABLE_INTERCOM') === 'true') {
    return;
  }
  if (window && window.Intercom && typeof window.Intercom === 'function') {
    window.Intercom('boot', {
      app_id: env('INTERCOM_KEY'),
      user_id: userId,
      name,
      email
    });
  }
};
